export default __webpack_public_path__ + "static/media/knight02.662c4c6b.jpg";